import React,{ Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { Row, Col, Table, Button, Card, CardBody, CardHeader} from "reactstrap";
import { getLdapId } from "../../../actions/actionLdap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Ldap",path:"/ldap",isActive: false},
    {name: "ViewLdap",path:"/viewldap",isActive: true},
];

class ViewLdap extends Component{
    constructor(props){
        super(props);
        this.state = {
            userId: null
        };
    }

    componentDidMount(){
        this.props.getLdapId(this.props.match.params.id);
    }

    render(){
        const {ldap_config} = this.props;
        return (
            <div>  
                <BreadCrumbCompo routes={routes}/>    
                <Row>
                    <Col sm={{ size: 8, order: 3, offset: 2 }}>
                        <Card >
                            <CardHeader>
                                <i className="fa fa-align-justify"></i> <strong>View LDAP Configuration</strong>
                                {ldap_config ? <Link className="pull-right" to={{ pathname: `/updateldap/${ldap_config.ldap_id}`}}> 
                                    <Button size="sm" color="dark"> Edit LDAP Configuration </Button> </Link> :" "}
                            </CardHeader>
                            <CardBody>
                                <Row>
                                    <Col xs="12">                    
                                        <div>
                                            {ldap_config?
                                                <Table bordered>
                                                    <tbody>
                                                        <tr><td>Ldap Id</td><td>{ldap_config.ldap_id}</td></tr>
                                                        <tr><td>Name</td><td>{ldap_config.name}</td></tr>
                                                        <tr><td>Url</td><td>{ldap_config.url}</td></tr>  
                                                        <tr><td>Search Base</td><td>{ldap_config.search_base}</td></tr>
                                                        <tr><td>Search Filter</td><td>{ldap_config.search_filter}</td></tr> 
                                                        <tr><td>Group Membership Filter</td><td>{ldap_config.group_membership_filter}</td></tr>
                                                        <tr><td>Email attribute</td><td>{ldap_config.email_attribute?ldap_config.email_attribute:"NA"}</td></tr>
                                                        <tr><td>Service Account DN</td><td>{ldap_config.service_account_dn}</td></tr>
                                                        <tr><td>Search Subtree</td><td>{ldap_config.search_subtree?"true":"false"}</td></tr>
                                                        <tr><td>Auto Create App User</td><td>{ldap_config.auto_create_app_user?"true":"false"}</td></tr>
                                                        <tr><td>Enabled</td><td>{ldap_config.enabled?"true":"false"}</td></tr>                                                                                           
                                                    </tbody>                            
                                                </Table> : " "}  
                                        </div>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>   
                    </Col>
                </Row>
            </div>
        );}
}

ViewLdap.propTypes = {
    getLdapId: Proptypes.func.isRequired,
    ldap_config: Proptypes.object,
    match: Proptypes.object
};

export default connect(state => 
    ({
        ldap_config: state.ldap_configs.ldap_config || null
    }),
dispatch => 
    ({  
        getLdapId: (data) => dispatch(getLdapId(data)),
    }))(ViewLdap);


// WEBPACK FOOTER //
// ./src/views/Ldap/ViewLdap/ViewLdap.js